/**
 * i18n System - Main Export
 *
 * Modular translation system following the king-dom pattern.
 * Organized by feature/domain rather than by language.
 *
 * translations/
 * +-- common/       # Shared translations (actions, labels)
 * +-- job/          # Job posting display
 * +-- application/  # Application form and modal
 */

import type { Language } from './config'
import { common } from './common'
import { job } from './job'
import { application } from './application'

export type LanguageTranslations = Record<string, string>

function buildTranslations(language: Language): LanguageTranslations {
  return {
    ...common[language],
    ...job[language],
    ...application[language],
  }
}

export const translations: Record<Language, LanguageTranslations> = {
  pt: buildTranslations('pt'),
  en: buildTranslations('en'),
}

export * from './config'
